import { IconButton, SxProps, Theme } from '@mui/material';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import UnfoldLessIcon from '@mui/icons-material/UnfoldLess';
import { useStandardDashboardFullscreen } from 'layouts/ResizableDashboardLayout';
import { SGTooltip } from 'components/core';
import { DashboardLayoutType } from 'types/shared';
import {
  useVerticalDashboardFullscreen,
  VerticalDashboardContextType,
} from 'layouts/VerticalDashboardLayout';

interface PanelFoldButtonProps {
  panelType: 'bottom' | 'top' | 'main';
  sx?: SxProps<Theme>;
  showTooltip?: boolean;
  layoutType?: DashboardLayoutType;
}

const PanelFoldButton = ({
  panelType,
  sx,
  showTooltip = true,
  layoutType = DashboardLayoutType.RESIZABLE_STANDARD,
}: PanelFoldButtonProps) => {
  const useFullscreenHook =
    layoutType === DashboardLayoutType.RESIZABLE_STANDARD
      ? useStandardDashboardFullscreen
      : useVerticalDashboardFullscreen;

  const hook = useFullscreenHook();

  const isCollapsed =
    panelType === 'bottom'
      ? hook.isBottomCollapsed
      : panelType === 'top'
        ? hook.isTopCollapsed
        : layoutType === DashboardLayoutType.RESIZABLE_VERTICAL &&
          (hook as VerticalDashboardContextType)?.isMainCollapsed;

  const toggleExpand = () => {
    if (panelType === 'bottom') {
      hook.toggleExpandBottom();
    } else if (panelType === 'top') {
      hook.toggleExpandTop();
    } else {
      (hook as VerticalDashboardContextType)?.toggleExpandMain();
    }
  };

  const button = (
    <IconButton
      data-ph-capture-attribute-element={`panel-fold-${panelType}`}
      color="primary"
      onClick={toggleExpand}
      sx={sx}
    >
      {isCollapsed ? <UnfoldMoreIcon /> : <UnfoldLessIcon />}
    </IconButton>
  );

  if (!showTooltip) {
    return button;
  }

  return (
    <SGTooltip title={isCollapsed ? 'Expand' : 'Collapse'}>{button}</SGTooltip>
  );
};

export default PanelFoldButton;
